export const  mapFields = function(module, fields) {
    const computeds = {}
    for (const field of fields) {
        computeds[field] = {
            get() {
                return this.$store.state[module][field]
            },
            set(value) {
                this.$store.commit(module + '/UPDATE_' + field.toUpperCase(), value)
            }
        }
    }
    return computeds
}